// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_e2-2";
export var aiChatCartContainerExit = "_e2-4";
export var aiChatContainerLarge = "_e2-0";
export var aiChatContainerSmall = "_e2-1";
export var aiChatIcon = "_e2-6";
export var slideInFromRight = "_e2-3";
export var slideOutToRight = "_e2-5";